import { useRef, useEffect, useState } from "react";
import {
  Text,
  ActionIcon,
  Container,
  Group,
  List,
  Title,
  Badge,
} from "@mantine/core";
import { useStore } from "../store";
import { deletePlugin, getPlugins } from "../api.js";
import PluginUploader from "./PluginUploader.jsx";
import { IconTrash } from "@tabler/icons-react";

export default function PluginManager() {
  const plugins = useStore((state) => state.pluginData);
  const setPlugins = useStore((state) => state.setPluginData);
  const [isDeleting, setIsDeleting] = useState(false);
  const initialized = useRef(false);

  const confirmDelete = (pluginId) => {
    if (confirm("Are you sure you want to delete the selected plugin?")) {
      setIsDeleting(true);
      deletePlugin(pluginId)
        .then(() => {
          setIsDeleting(false);
          setPlugins(plugins.filter((p) => p.id !== pluginId));
        })
        .catch((error) => {
          alert(
            "Something went wrong while deleting, please try again. Details: " +
              error
          );
        });
    }
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getPlugins().then((data) => {
        setPlugins(data);
      });
    }
  }, [setPlugins]);

  return (
    <Container>
      <Group mt="sm" mb="lg" justify="space-between">
        <Title>Plug Ins</Title>
        <Badge color="red">Experimental</Badge>
      </Group>

      {/* {!activated && (
        <Alert color="red" mb="md">
          You need a subscription to use this feature. Please visit the{" "}
          <Link to="/profile">profile page</Link> to manage your subscription.
        </Alert>
      )} */}

      <PluginUploader />

      <Text fw={600} fz="lg" mt="lg">
        Installed Plugins
      </Text>

      {plugins?.length === 0 && <Text>No plugins installed at present</Text>}

      <List>
        {plugins?.map((plugin) => (
          <List.Item key={plugin.id}>
            <Group>
              <Text>
                {plugin.pluginTitle}
                {plugin.version ? ` v${plugin.version}` : ""}
                {" "}({plugin.active ? "active" : "NOT active"})
                {plugin.sourceUrl ? " (auto-updating)" : ""}
              </Text>
              <ActionIcon
                loading={isDeleting}
                variant="outline"
                color="red"
                onClick={() => confirmDelete(plugin.id)}
              >
                <IconTrash size={16} stroke={1.2} />
              </ActionIcon>{" "}
            </Group>
          </List.Item>
        ))}
      </List>
    </Container>
  );
}
